// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PlanningModalCreneauDelete_delete__VyVL1 {\n  top: 8px;\n  right: 41px;\n  position: absolute;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Planning/PlanningModalCreneauDelete.module.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".delete {\n  top: 8px;\n  right: 41px;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delete": "PlanningModalCreneauDelete_delete__VyVL1"
};
export default ___CSS_LOADER_EXPORT___;
